import { EventTypes } from 'modules/domains/segmentation';
import { ApiError } from 'services/api';

export const getEventInfo = (
  dataType: EventTypes,
  events: Record<EventTypes, string>,
  defaultName: string,
) => (events[dataType] !== events[EventTypes.CustomEvent] ? events[dataType] : defaultName);

export const retryOnPartialContent = (failureCount: number, error: ApiError) =>
  error.response?.status === 206;
